const KEY = 'APP_ROUTE';

export { KEY };
